module.exports = "/images/club-blank.svg?72db1c6aa0e94e39e660ccc78656d09e";